var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid h-100",attrs:{"id":"app"}},[_c('div',{staticClass:"row h-100 position-absolute"},[_c('div',{staticClass:"col p-0 h-100"},[_c('div',{ref:"bgSvgEl",staticClass:"h-100 w-100 position-fixed"})])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }